import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube, ChevronUp, MapPin, Mail, Phone } from 'lucide-react';
import { useSite } from '../../context/SiteContext';
import './Footer.css';

const Footer = () => {
  const { siteName, fullAddress, email, phone } = useSite();
  const [emailInput, setEmailInput] = useState('');
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowBackToTop(window.scrollY > 400);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    alert('Thanks for subscribing!');
    setEmailInput('');
  };

  const footerLinks = {
    shop: [
      { name: 'Women', href: '/category/women' },
      { name: 'Men', href: '/category/men' },
      { name: 'Kids', href: '/category/kids' },
      { name: 'Home', href: '/category/home' },
      { name: 'Shoes', href: '/category/shoes' },
      { name: 'Handbags', href: '/category/handbags' },
      { name: 'Jewelry', href: '/category/jewelry' },
      { name: 'Beauty', href: '/category/beauty' },
    ],
    customerService: [
      { name: 'Contact Us', href: '/contact' },
      { name: 'FAQs', href: '/faqs' },
      { name: 'Shipping Info', href: '/shipping' },
      { name: 'Returns', href: '/returns' },
    ],
    about: [
      { name: `About ${siteName}`, href: '/about' },
      { name: 'Careers', href: '/careers' },
      { name: 'Press Room', href: '/press' },
    ],
    rewards: [
      { name: 'Star Rewards', href: '/rewards' },
      { name: 'Gift Cards', href: '/gift-cards' },
      { name: 'Coupons', href: '/coupons' },
    ],
  };

  const paymentMethods = ['VISA', 'MC', 'AMEX', 'DISC', 'PayPal'];

  return (
    <footer className="footer">
      <div className="footer-email-signup">
        <div className="footer-email-container">
          <div className="footer-email-text">
            <h3>Get Exclusive Offers & Updates</h3>
            <p>Sign up for emails and get 25% off!</p>
          </div>
          <form className="footer-email-form" onSubmit={handleEmailSubmit}>
            <input type="email" placeholder="Enter your email" className="footer-email-input" value={emailInput} onChange={(e) => setEmailInput(e.target.value)} required />
            <button type="submit" className="footer-email-button">Sign Up</button>
          </form>
        </div>
      </div>

      <div className="footer-main">
        <div className="footer-grid">
          <div className="footer-column">
            <h4>Shop</h4>
            <ul className="footer-links">
              {footerLinks.shop.map((link) => (
                <li key={link.name}><Link to={link.href}>{link.name}</Link></li>
              ))}
            </ul>
          </div>
          <div className="footer-column">
            <h4>Customer Service</h4>
            <ul className="footer-links">
              {footerLinks.customerService.map((link) => (
                <li key={link.name}><Link to={link.href}>{link.name}</Link></li>
              ))}
            </ul>
          </div>
          <div className="footer-column">
            <h4>About</h4>
            <ul className="footer-links">
              {footerLinks.about.map((link) => (
                <li key={link.name}><Link to={link.href}>{link.name}</Link></li>
              ))}
            </ul>
          </div>
          <div className="footer-column">
            <h4>Rewards</h4>
            <ul className="footer-links">
              {footerLinks.rewards.map((link) => (
                <li key={link.name}><Link to={link.href}>{link.name}</Link></li>
              ))}
            </ul>
          </div>
          <div className="footer-column">
            <h4>Contact</h4>
            <div className="footer-contact">
              <p><MapPin size={14} /> {fullAddress}</p>
              <p><Mail size={14} /> <a href={`mailto:${email}`}>{email}</a></p>
              <p><Phone size={14} /> <a href={`tel:${phone}`}>{phone}</a></p>
            </div>
          </div>
          <div className="footer-column">
            <h4>Connect</h4>
            <div className="footer-social">
              <a href="#" className="footer-social-link"><Facebook size={18} /></a>
              <a href="#" className="footer-social-link"><Twitter size={18} /></a>
              <a href="#" className="footer-social-link"><Instagram size={18} /></a>
              <a href="#" className="footer-social-link"><Youtube size={18} /></a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p className="footer-copyright">© {new Date().getFullYear()} {siteName}. All Rights Reserved.</p>
          <div className="footer-legal">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Use</Link>
            <Link to="/privacy#do-not-sell">Do Not Sell or Share My Personal Information</Link>
          </div>
        </div>
        <div className="footer-payments">
          <span style={{ fontSize: '12px', color: '#999', marginRight: '8px' }}>We Accept:</span>
          {paymentMethods.map((method) => (
            <span key={method} className="footer-payment-icon">{method}</span>
          ))}
        </div>
      </div>

      <button className={`footer-back-top ${showBackToTop ? 'visible' : ''}`} onClick={scrollToTop}>
        <ChevronUp size={24} />
      </button>
    </footer>
  );
};

export default Footer;
